<template>
	<el-dialog
		title="预警详情"
		:visible.sync="dialogVisible"
		width="40%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="基本信息" name="1">
				<el-card shadow="never" class="table-card">
					<el-descriptions title="合同信息" :column="2" border>
						<el-descriptions-item label="合同编号">HT202604001</el-descriptions-item>
						<el-descriptions-item label="合同名称">A栋广告位租赁合同</el-descriptions-item>
						<el-descriptions-item label="资源编号">ZY-2025-007-2</el-descriptions-item>
						<el-descriptions-item label="资源名称">1号楼1单元电梯广告</el-descriptions-item>
						<el-descriptions-item label="资源类型">广告位</el-descriptions-item>
						<el-descriptions-item label="所属项目">中山首府</el-descriptions-item>
						<el-descriptions-item label="租客名称">五粮液集团</el-descriptions-item>
						<el-descriptions-item label="租客电话">13862280921</el-descriptions-item>
					</el-descriptions>
				</el-card>
				<el-card shadow="never">
					<el-descriptions title="租赁信息" :column="2" border>
						<el-descriptions-item label="面积">10㎡</el-descriptions-item>
						<el-descriptions-item label="租金单价">30元/㎡/月</el-descriptions-item>
						<el-descriptions-item label="月租金">300元</el-descriptions-item>
						<el-descriptions-item label="支付方式">月付</el-descriptions-item>
						<el-descriptions-item label="押金金额">300元</el-descriptions-item>
						<el-descriptions-item label="缴费日期">2026-04-01</el-descriptions-item>
						<el-descriptions-item label="签约日期">2026-04-01</el-descriptions-item>
						<el-descriptions-item label="到期日期">2027-03-31</el-descriptions-item>
					</el-descriptions>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="租金记录" name="2">
				<el-table
					:data="tableData"
					max-height="350"
					border
					style="width: 100%"
					show-summary
					:summary-method="getSummaries">
					<el-table-column prop="cycle" label="缴费周期" width="120" />
					<el-table-column prop="amount" label="实收金额">
						<template #default="{ row }">¥ {{ row.amount }}</template>
					</el-table-column>
					<el-table-column prop="payTime" label="缴费日期" />
					<el-table-column prop="payMethod" label="收款方式" width="120" />
					<el-table-column label="状态" width="100">
						<template #default="{ row }">
							<el-tag :type="row.status === '已收款' ? 'success' : 'warning'">
								{{ row.status }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="operator" label="操作人" />
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="关联资源" name="3">
				<el-card shadow="never">
					<el-descriptions :column="2" border>
						<el-descriptions-item label="资源名称">1号楼1单元电梯广告</el-descriptions-item>
						<el-descriptions-item label="资源编号">ZY-2025-007-2</el-descriptions-item>
						<el-descriptions-item label="资源类型">广告位</el-descriptions-item>
						<el-descriptions-item label="所属项目">中山首府</el-descriptions-item>
						<el-descriptions-item label="关联资产">A栋广告位资产</el-descriptions-item>
						<el-descriptions-item label="面积(m²)">10</el-descriptions-item>
						<el-descriptions-item label="租金单价">30元/㎡/月</el-descriptions-item>
						<el-descriptions-item label="当前状态">
							<el-tag type="success">已出租</el-tag>
						</el-descriptions-item>
					</el-descriptions>
				</el-card>
			</el-tab-pane>
		</el-tabs>
		<!-- 按钮 -->
		<span slot="footer">
			<el-button @click="handleClose">关 闭</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		name: 'RiskPreventionContractDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		data() {
			return {
				activeName: '1',
				tableData: [
					{
						cycle: '2026年4月',
						amount: '300',
						payTime: '2026-04-01 09:30:00',
						payMethod: '银行转账',
						status: '已收款',
						operator: '系统管理员',
					},
					{
						cycle: '2026年5月',
						amount: '300',
						payTime: '2026-05-01 10:15:00',
						payMethod: '银行转账',
						status: '已收款',
						operator: '系统管理员',
					},
					{
						cycle: '2026年6月',
						amount: '300',
						payTime: '2026-06-01 14:20:00',
						payMethod: '微信',
						status: '已收款',
						operator: '系统管理员',
					},
					{
						cycle: '2026年7月',
						amount: '200',
						payTime: '2026-07-01 11:00:00',
						payMethod: '银行转账',
						status: '已收款',
						operator: '系统管理员',
					},
					{
						cycle: '2026年8月',
						amount: '300',
						payTime: '-',
						payMethod: '-',
						status: '待收款',
						operator: '-',
					},
				],
			};
		},
		methods: {
			getRiskType(level) {
				const map = {
					严重: 'danger',
					紧急: 'warning',
					一般: 'info',
				};
				return map[level] || 'info';
			},
			getStatusType(status) {
				const map = {
					未读: 'info',
					已读: 'success',
					处理中: 'warning',
					已关闭: 'danger',
				};
				return map[status] || 'info';
			},
			getSummaries(param) {
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总价';
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] = '¥ ' + sums[index];
					} else {
						sums[index] = '';
					}
				});
				return sums;
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}

		.table-card {
			margin-bottom: 20px;
		}
		.tb-foot {
			margin-bottom: 20px;
			display: flex;
			font-size: 16px;
			color: #333;
		}
	}
</style>
